import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 via-primary-900 to-neutral-900 pt-20">
      <Contact />
    </div>
  );
};

export default ContactPage;
